import React, { Suspense, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import media from 'utils/mediaStyle';
import styled from 'styled-components';
import LoadingIndicator from 'components/LoadingIndicator';
import { ErrorBoundary } from 'components/ErrorBoundary';
import CategoryNavMobile from 'containers/CategoryNavMobile';

interface ProductListingContentProps {
  component: any;
  matchProps: RouteComponentProps;
}

const Main = styled.div`
  display: flex;
  flex-direction: column;
  ${media.lg`
    flex-direction: row;
  `};
`;

const MainContainer = styled.div<{ $fillViewport?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({ $fillViewport }) =>
    $fillViewport &&
    `
    min-height: calc(100vh - 53px);
  `}
`;

function ProductListingContent({ component: Component, matchProps }: ProductListingContentProps) {
  const [openSearchFilter, setOpenSearchFilter] = useState(false);
  const [canClearFilter, setCanClearFilter] = useState(false);
  const isFavoritePage = matchProps.location.pathname === '/favorite';

  return (
    <Main>
      <CategoryNavMobile canClearFilter={canClearFilter} openFilterSearch={() => setOpenSearchFilter(true)} />
      <Suspense
        fallback={
          <MainContainer $fillViewport>
            <LoadingIndicator isHomePage={window.location.pathname === '/'} />
          </MainContainer>
        }
      >
        <MainContainer $fillViewport={!isFavoritePage}>
          <ErrorBoundary key={matchProps.location.pathname}>
            <Component
              key={matchProps.location.pathname}
              openSearchFilter={openSearchFilter}
              setOpenSearchFilter={setOpenSearchFilter}
              canClearFilter={canClearFilter}
              setCanClearFilter={setCanClearFilter}
              {...matchProps}
            />
          </ErrorBoundary>
        </MainContainer>
      </Suspense>
    </Main>
  );
}

export default ProductListingContent;
